import React, { useState, useMemo } from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';
import Grid from '@mui/material/Unstable_Grid2';
import { fieldSizing } from '../../utils/utilities';
import FieldInfo from '../FieldInfo/FieldInfo';

import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Autocomplete from '@mui/material/Autocomplete';

export default function SelectCustom({
    label,
    name,
    options,
    fullWidth = true,
    value,
    setValue,
    error = false,
    errorMsg = "This is a required field.",
    required,
    size = "L",
    withInfo = false,
    description,
    disabled
}) {
    const variant = "outlined"
    const labelId = "demo-simple-select-label"
    // const id = "demo-simple-select"

    const [defaultVal, setDefaultVal] = useState("")

    const handleChange = (ev) => {

        if (setValue) {
            setValue(ev.target.value);
        } else {
            setDefaultVal(ev.target.value)
        }
    }

    // const handleOnBlur = (ev) => {
    //     console.log(ev.target.value)

    // }

    const fieldSize = useMemo(() =>
        fieldSizing(size)
        , [])

    return (
        <Grid xs={fieldSize.xs} sm={fieldSize.sm} md={fieldSize.md} lg={fieldSize.lg} >
            <div className="field-container" >
                <FormControl variant={variant} fullWidth={fullWidth} error={error} >
                    {/* <InputLabel ></InputLabel>
                    <Select
                        labelId={labelId}
                        // id={id}
                        label={label}
                        value={value ? value : defaultVal}
                        name={name}
                        onChange={handleChange}
                        error={error}
                        disabled={disabled}
                    >
                        {options?.map((item) => {
                            return <MenuItem value={item} key={item}>{item}</MenuItem>
                        })}

                    </Select> */}

                    <Autocomplete
                        freeSolo
                        options={options.map((item) => item)}
                        renderInput={(params) => <TextField {...params} label={required ? label+ " *" : label} />}
                        // onChange={handleChange}
                        value={value ? value : defaultVal}
                        name={name}
                        onBlur={handleChange}
                        // error={true}
                        disabled={disabled}
                    />
                </FormControl>
                {withInfo &&
                    <FieldInfo content={description} />
                }
            </div>
            <FormHelperText error> {error ? errorMsg : ""} </FormHelperText>

        </Grid>
    );
}